import request from '@/common/js/request';

/**
 * 获取分页数据
 */
export const getPage = (params) => {
    return request('/baseRole/listPage',{
        params,
        method: 'get'
    })
}
/**
 * 保存数据
 */
export const save = (data) => {
    return request('/baseRole/save',{
        data: data,
        method: 'post'
    })
}
/**
 * 删除
 */
export const deleteById = (id) => {
    return request('/baseRole/delete/',{
        data: id,
        method: 'DELETE'
    })
}

/**
 * 获取KeyValue分页数据
 */
export const getKeyValuePage = (params) => {
    return request('/baseRole/listPage',{
        params,
        method: 'get'
    })
}
/**
 * KeyValue保存数据
 */
/**
 * 保存数据
 */
export const saveKeyValue = (data) => {
    return request('',{
        data: data,
        method: 'post'
    })
}

/**
 * KeyValue删除
 */
export const deleteKeyValueById = (id) => {
    return request(''+id,{
        method: 'DELETE'
    })
}

/**
 * 获取根据类型获取字典数据列表
 */
export const getDictDataListByDictType = (data) => {
    return request('/baseDictData/list',{
      params: data,
      method: 'get'
    })
  }